import React from 'react';
import PropTypes from 'prop-types';

import IconWithText from 'components/Widgets/IconWithText';

export default function Location({ coach }) {
  return (
    <div className="mb-4 p-3 border rounded-4">
      <h6 className="mb-3">
        Location + Time Zone
      </h6>

      <div className="fw-light">
        <IconWithText
          iconClassName="location-icon small-icon bg-tertiary-1000"
          wrapperClassName="mb-3 align-items-start"
          contentClassName="small"
        >
          {coach.attributes.location}
        </IconWithText>

        <IconWithText
          iconClassName="clock-icon small-icon bg-tertiary-1000"
          wrapperClassName="align-items-start"
          contentClassName="small"
        >
          {coach.attributes.time_zone_offset}
        </IconWithText>
      </div>
    </div>
  );
}

Location.propTypes = {
  coach: PropTypes.object.isRequired,
};
